import { DialogTitle, DialogContent } from '@mui/material';
import FormInputText from '@components/forms/FormInputText';

const UserInfoStep = () => {
    return (
        <>
            <DialogTitle>About You</DialogTitle>
            <DialogContent>
                <FormInputText
                    name="firstName"
                    label="First Name"
                    rules={{ required: true, min: 3 }}
                />
                <FormInputText
                    name="lastName"
                    label="Last Name"
                    rules={{ required: true, min: 3 }}
                />
            </DialogContent>
        </>
    );
};

export default UserInfoStep;
